import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { content } from '../data/content';

const About = () => {
  const { language } = useContext(LanguageContext);
  const { title, description, vision, visionText, mission, missionText } = content[language].about;
  
  return (
    <section id="about" className="section bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">{title}</h2>
          <p className="text-lg text-gray-700 mb-8">{description}</p>
          
          <div className="grid md:grid-cols-2 gap-8 mt-12">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-blue-700 mb-4">{vision}</h3>
              <p className="text-gray-700">{visionText}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-blue-700 mb-4">{mission}</h3>
              <p className="text-gray-700">{missionText}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
